import module from 'fan/proyecto/module.js'
import template from './template.html'

export class FanProyectoColaboradoresAgregarComponent {
  constructor($state) {
    this.$state = $state
    this.idProyecto = null
  }

  $onInit() {
    this.info = {
      ID_Empresa: this.idProyecto,
      ID_Empleado: '',
      tipo_persona: (Number(this.idProyecto) < 7 && this.idProyecto !== '00') ? 'M' : 'F',
    }
  }

  cancelado() {
    this.$state.go('^.lista')
  }

  creado($event) {
    this.data = $event
  }

  nuevo() {
    this.$state.reload()
  }
}

module.component('fanProyectoColaboradoresAgregar', {
  controller: FanProyectoColaboradoresAgregarComponent,
  template: template,
  bindings: {
    idProyecto: '<',
  },
})



// WEBPACK FOOTER //
// ./src/fan/proyecto/components/colaboradores/agregar/component.js